import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SYSTEMCATEGORY } from '../../../services/auth/auth.service';

@Component({
  selector: 'ag-online-content',
  templateUrl: './online-content.component.html',
  styleUrls: ['./online-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineContentComponent {
  @Input() fullRecord: any;
  @Input() itemIndex = -1;

  SYSTEMCATEGORY = SYSTEMCATEGORY;
  position = 0;
}
